export default __webpack_public_path__ + "static/media/top-part-1.a62b5846.png";